<template>
  <div>
    <!-- 盒子 -->
    <!-- <div class="border_parent">
            <div class="content">
                <Container :items="items" v-if="flag"/>
            </div>
        </div> -->
    <b-row>
      <b-tabs pills card :vertical="iswin ? true : false">
        <b-tab v-for="item in items" :title="item.name" active
          ><el-card> <div v-html="item.content"></div> </el-card
        ></b-tab>
        <b-tab title="研究所活动"><Activity></Activity></b-tab>
      </b-tabs>
    </b-row>
  </div>
</template>

<script>
import Container from "../components/Container.vue";
import Activity from "./Activity.vue";
import request from "../utils/request";
export default {
  name: "Recruit",
  data() {
    return {
      iswin: true,
      requestUrl: {
        getPage: "/article/page",
      },
      items: [],
      flag: false,
    };
  },
  components: {
    Container,
    Activity,
  },
  created() {
    this.getData();
  },
  mounted() {
    this.checkWindowWidth(); // 初始化时检查窗口大小
    window.addEventListener("resize", this.checkWindowWidth); // 监听窗口大小变化
  },
  methods: {
    // 获取列表数据
    getData() {
      request
        .get(this.requestUrl.getPage, {
          params: {
            name: "",
            pageNum: 1,
            pageSize: 10000,
            type: 2,
          },
        })
        .then((res) => {
          if (res.code === "200") {
            this.items = res.data.records;
            this.flag = true;
          } else {
            this.$message.error("获取失败");
          }
        });
    },

    checkWindowWidth() {
      if (window.innerWidth > 1000) {
        this.iswin = true;
      } else {
        this.iswin = false;
      }
    },
  },
};
</script>

<style scoped>
* {
  font: Helvetica, STHeiti STXihei, Microsoft JhengHei, Microsoft YaHei, Tohoma, Arial;
  color: #313131;
}

.tab_b:hover {
  background-color: #032252;
}
div/deep/ .nav-pills {
  --bs-nav-pills-border-radius: 0;
  --bs-nav-pills-link-active-color: #fbc52c;
  --bs-nav-pills-link-active-bg: #002d71;
}
div/deep/.nav {
  --bs-nav-link-color: #fff;
  font-size: larger;
  --bs-nav-link-hover-color: #fbc52c;
  background-color: #002d71;
}
div/deep/.nav-item:hover {
  background-color: #032252;
}
div/deep/ .col-auto {
  margin: auto;
  margin-top: 0;
  width: 250px;
}
.border_parent {
  width: 90%;
  margin: 20px auto;
}
.content {
  width: 100%;
  margin: 0 auto;
}
</style>
